import React, { useState, useEffect } from 'react';
import { preloadAllRouteChunks } from '../../utils/routePreload';
import './HamburgerIcon.css';
import SlideMenu from '../SlideMenu/SlideMenu';
const HamburgerIcon = ({ onClick }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        if (isOpen) {
            document.body.classList.add('no-scroll');
        } else {
            document.body.classList.remove('no-scroll');
        }

        return () => {
            document.body.classList.remove('no-scroll');
        };
    }, [isOpen]);

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            setIsScrolled(scrollTop > 0);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const handleClick = () => {
        setIsOpen(!isOpen);
        if (onClick) onClick();
    };

    return (
        <>
            <button
                className={`hamburger-icon ${isOpen ? 'open' : ''} ${isScrolled ? 'scrolled' : ''}`}
                onClick={handleClick}
                onMouseEnter={preloadAllRouteChunks}
                onFocus={preloadAllRouteChunks}
                aria-label="Menu"
                style={{ position: 'fixed', zIndex: 200 }}
            >
                <div className="icon-lines">
                    <span className="line"></span>
                    <span className="line"></span>
                    <span className="line"></span>
                </div>
                <h1>{isOpen ? 'CLOSE' : 'MENU'}</h1>
            </button>
            <SlideMenu isOpen={isOpen} onClose={() => setIsOpen(false)} />
        </>
    );
};

export default HamburgerIcon;
